import 'react-app-polyfill/ie11';
import React, { ReactElement, Suspense, useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';

// Load in our global stylesheets.
import './styles/reset.scss';
import './styles/base.scss';
import { BrowserNotSupported } from './components/BrowserNotSupported/BrowserNotSupported';
import { initializeTracking, trackException } from './utils/trackingUtils';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import About from './components/About/About';
import { getIosVersion } from './utils/getIosVersion';

// Load components and clients.
// tslint:disable-next-line: variable-name
const App = React.lazy(() => import('./components/App/App'));

function Index(): ReactElement {
  const [hasTested, setHasTested] = useState(false);
  const [isBrowserSupported, setIsBrowserSupported] = useState(false);

  useEffect(() => {
    window.AudioContext = window.AudioContext || window.webkitAudioContext;
    const iosVersion = getIosVersion();
    if (window.AudioContext && (iosVersion === -1 || iosVersion > 11)) {
      setIsBrowserSupported(true);
    } else {
      trackException({
        description: 'Browser not supported',
        fatal: true,
      });
    }
    setHasTested(true);
  }, []);

  return (
    hasTested && (
      <>
        <Router basename="/tonetransfer">
          <Switch>
            <Route exact path="/">
              {isBrowserSupported ? (
                <Suspense
                  fallback={
                    /* Inline styles to prevent flash of unstyled loader */
                    <div
                      className="preloader"
                      style={{
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        justifyContent: 'center',
                        textAlign: 'center',
                        width: '100%',
                      }}
                    >
                      <span style={{ fontSize: 20, fontWeight: 700 }}>
                        Loading...
                      </span>
                      <img
                        alt=""
                        height="auto"
                        role="presentation"
                        src={process.env.PUBLIC_URL + '/images/preloader.png'}
                        width={155}
                      />
                    </div>
                  }
                >
                  <App />
                </Suspense>
              ) : (
                <BrowserNotSupported />
              )}
            </Route>
            <Route path="/about">
              <About showHeader />
            </Route>
          </Switch>
        </Router>
      </>
    )
  );
}

// Render our DOM element.
ReactDOM.render(<Index />, document.getElementById('react-root'));

// Initialize Google Analytics.
initializeTracking();
